import React from 'react';
import { VStack, Box } from '@chakra-ui/react';
import SanityImage from 'gatsby-plugin-sanity-image';
import { RichText } from '../RichText';

const textColors = {
  navy: 'white',
  'grey.blue': 'black',
  white: 'black',
  grey: 'black',
};

function CalloutBox({ data }) {
  const { title, body, image, backgroundColor } = data || {};
  return (
    <VStack
      align='left'
      spacing={10}
      backgroundColor={backgroundColor || 'navy'}
      padding={30}
      color={textColors[backgroundColor] || 'black'}
      className={`callout-box ${backgroundColor === 'navy' && 'white-text'}`}
    >
      {image && (
        <Box mb={10}>
          <SanityImage
            {...image}
            alt={image?.asset?.altText}
            width={560}
            style={{
              width: '100%',
              height: 'auto',
              objectFit: 'cover',
            }}
          />
        </Box>
      )}
      {title && <RichText value={title} as='h2' textStyle='h2' mb={20} />}
      {body && (
        <RichText
          display='flex'
          flexDirection='column'
          gap={10}
          fontSize='md'
          fontWeight={300}
          value={body}
        />
      )}
    </VStack>
  );
}

export default CalloutBox;
